import { addAddressesWithNoDuplicates } from '../normalizers/uiNeeds';
import { commonTypes } from '../common';

export const types = {
  SET_INVALID_EMAIL: 'UINEEDS/SET_INVALID_EMAIL',
  SET_SHOW_ADVERTISING_USE_CHECK: 'UINEEDS/SET_SHOW_ADVERTISING_USE',
  SET_PERSONAL_CONTACT: 'UINEEDS/SET_PERSONAL_CONTACT',
};

export const initialState = {
  clientInfo: null,
  clientAddresses: [],
  invalidEmail: false,
  showAdvertisingUseCheck: false,
};

const UINeedsPersonalDataReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_CLIENT_INFO: {
      const {
        name,
        fullName,
        docNumber,
        contactEmail,
        contactPhone,
        contactAddress,
        permanentResidence,
        companyName,
        docTypeText,
      } = action.payload;

      const permanentResidenceNormalized = {
        locationId: null,
        fullAddress: null,
      };

      let newClientAddresses = state.clientAddresses;
      if (permanentResidence) {
        permanentResidenceNormalized.locationId = permanentResidence.id;
        permanentResidenceNormalized.fullAddress = permanentResidence.locationFullAddress;

        newClientAddresses = addAddressesWithNoDuplicates(state.clientAddresses, [permanentResidenceNormalized]);
      }

      const newState = {
        ...state,
        clientInfo: {
          name: name,
          fullName: companyName || fullName,
          isCompany: !!companyName,
          docType: docTypeText,
          docNumber,
          contactAddress: {
            id: contactAddress.contactId,
            address: contactAddress.value,
          },
          contactPhone: contactPhone ? contactPhone.value : '',
          email: contactEmail ? contactEmail.value : '',
          permanentResidence,
        },
        clientAddresses: newClientAddresses,
        showAdvertisingUseCheck: false,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SET_PERSONAL_CONTACT: {
      const { contactPhone, email } = action.payload;

      const newState = {
        ...state,
        clientInfo: {
          ...state.clientInfo,
          contactPhone: state.clientInfo.contactPhone || contactPhone,
          email: state.clientInfo.email || email
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.SET_INVALID_EMAIL: {
      const { invalidEmail } = action.payload;

      const newState = {
        ...state,
        invalidEmail,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SET_SHOW_ADVERTISING_USE_CHECK: {
      const { showAdvertisingUseCheck } = action.payload;
      const newState = {
        ...state,
        showAdvertisingUseCheck,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case commonTypes.SET_PERMANENT_RESIDENCE_INFO: {
      const { locationId, fullAddress } = action.payload;
      return {
        ...state,
        clientInfo: {
          ...state.clientInfo,
          contactAddress: {
            id: locationId,
            address: fullAddress,
          },
          permanentResidence: {
            id: locationId,
            locationFullAddress: fullAddress,
          },
        },
      };
    }
    case commonTypes.SET_PERMANENT_RESIDENCE_ADDRESS_NAME: {
      const { address } = action.payload;
      return {
        ...state,
        clientInfo: {
          ...state.clientInfo,
          contactAddress: {
            ...state.clientInfo.contactAddress,
            address,
          },
          permanentResidence: {
            ...state.clientInfo.permanentResidence,
            locationFullAddress: address,
          },
        },
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setInvalidEmail: () => ({
    type: types.SET_INVALID_EMAIL,
    payload: {
      invalidEmail: true,
    },
  }),
  setShowAdvertisingUseCheck: () => ({
    type: types.SET_SHOW_ADVERTISING_USE_CHECK,
    payload: {
      showAdvertisingUseCheck: true,
    },
  }),
  setPersonalContact: (data) => ({
    type: types.SET_PERSONAL_CONTACT,
    payload: {
      ...data,
    },
  }),
};

export default UINeedsPersonalDataReducer;
